import React from 'react';

import { Route, Switch } from 'react-router-dom';

import Home from './Home/Home';
import ModelDetail from '../models/ModelDetail';
import ModelsIndex from '../models/ModelsIndex';
import OrchestrationDetail from '../orchestration/OrchestrationDetail/OrchestrationDetail';
import OrchestrationsIndex from '../orchestration/OrchestrationsIndex/OrchestrationsIndex';
import PageNotFound from './PageNotFound';
import PipelineDetail from '../pipelines/PipelineDetail';
import PipelineDetailSingleChart from '../pipelines/PipelineDetailSingleChart/PipelineDetailSingleChart';
import PipelinesIndex from '../pipelines/PipelinesIndex';
import Status from './Status/Status';

import useClientContext from '../contexts/ClientData/ClientData';

const orchestrationRoutes = [
  {
    id: 'orchestration-detail',
    path: '/workspaces/:workspaceId/orchestrations/:id',
    render: () => <OrchestrationDetail />,
  },
  {
    id: 'orchestration-index',
    path: '/workspaces/:workspaceId/orchestrations',
    exact: true,
    render: () => <OrchestrationsIndex />,
  },
]

export const routeConfig = [
  {
    id: 'pipeline-detail-single-chart',
    path: '/workspaces/:workspaceId/pipelines/:id/versions/:version/chart/:chartType',
    render: () => <PipelineDetailSingleChart />
  },
  {
    id: 'model-detail',
    path: '/workspaces/:workspaceId/models/:id/versions/:version',
    render: () => <ModelDetail />,
  },
  {
    id: 'pipeline-detail',
    path: '/workspaces/:workspaceId/pipelines/:id/versions/:version/:selectedTab',
    render: () => <PipelineDetail />,
  },
  {
    id: 'pipeline-detail',
    path: '/workspaces/:workspaceId/pipelines/:id/versions/:version',
    render: () => <PipelineDetail />,
  },
  {
    id: 'orchestration-detail',
    path: '/workspaces/:workspaceId/orchestrations/:id',
    render: () => <OrchestrationDetail />,
  },
  {
    id: 'status',
    path: '/workspaces/:workspaceId/status',
    render: () => <Status />,
  },
  {
    id: 'model-index',
    path: '/workspaces/:workspaceId/models',
    exact: true,
    render: () => <ModelsIndex />,
  },
  {
    id: 'pipeline-index',
    path: '/workspaces/:workspaceId/pipelines',
    exact: true,
    render: () => <PipelinesIndex />,
  },
  {
    id: 'orchestration-index',
    path: '/workspaces/:workspaceId/orchestrations',
    exact: true,
    render: () => <OrchestrationsIndex />,
  },
  {
    id: 'home',
    path: '/workspaces/:workspaceId',
    exact: true,
    render: () => <Home />,
  },
  {
    id: 'page-not-found',
    path: '*',
    render: () => <PageNotFound />,
  },
];

const RouteWrapper = ({
  path, exact, render, ...rest
}) => (
  <Route path={path} exact={exact} {...rest}>
    {render(rest)}
  </Route>
)

const PageRouter = () => {
  const { isOrchestrationEnabled } = useClientContext();
  const allRoutes = isOrchestrationEnabled ? [
    ...orchestrationRoutes, ...routeConfig
  ] : routeConfig;
  return (
    <Switch>
      {
        allRoutes.map(({
          path, exact, render, id,
        }) => (
          <RouteWrapper
            key={id}
            path={path}
            exact={exact}
            render={render}
          />
        ))
      }
    </Switch>
  )
}

export default PageRouter;
